/**
 * CardShimmer — skeleton for the product card grid (CardDesign)
 * Renders `count` placeholder cards matching the real card layout.
 */
const CardShimmer = ({ count = 8 }) => {
    return (
        <div className="container mx-auto px-4 sm:px-6 md:px-10">
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 gap-4">
                {Array.from({ length: count }).map((_, i) => (
                    <div
                        key={i}
                        className="flex flex-col bg-white rounded-[10px] overflow-hidden"
                    >
                        {/* Image placeholder */}
                        <div className="w-full aspect-product-desktop bg-gray-200 animate-pulse" />

                        {/* Text placeholders */}
                        <div className="p-2 md:px-3 flex flex-col gap-2">
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4" />
                            <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2" />
                            <div className="h-3 bg-gray-200 rounded animate-pulse w-1/3" />
                            {/* Button placeholder */}
                            <div className="flex gap-2 mt-2">
                                <div className="flex-1 h-8 bg-gray-200 rounded-md animate-pulse" />
                                <div className="w-10 h-8 bg-gray-200 rounded-md animate-pulse" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CardShimmer;
